import { Input } from "components";
import CopyToClipboard from "components/Atoms/CopyToClipboard";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { InPageEditableSectionField } from "components/MainSectionTemplate/types";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { containsAnyMergefields, getFilteredMergetopics } from "exceltemplate/ColumnsPanel/utils";
import React, { useEffect, useState } from "react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { useDebounce } from "utilities/usehooks";

interface MergefieldDetailSectionProps {
  pageTitle: string
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
}

export const MergefieldDetailSection = (props: MergefieldDetailSectionProps) => {
  const semanticRef = useSemanticUiInputRef();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery);

  const filteredMergeTopics = getFilteredMergetopics(props.availableMergeFieldTopics, debouncedSearchQuery)
    .filter(topic => containsAnyMergefields(topic));

  useEffect(() => {
    semanticRef.ref.current.focus();
  }, []);

  return <DetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    wideLabel
    sections={[{
      type: "regular",
      key: "mergefields",
      title: props.pageTitle,
      fields: [{
        key: "search",
        label: "",
        hideLabel: true,
        render: () => <Input
          ref={semanticRef.refSetter}
          onChange={(_, { value }) => { setSearchQuery(value); }}
          value={searchQuery}
          icon="search"
          placeholder={RESX.GeneralLabels.Search}
          fluid
        />
      }, {
        key: "noDataAvailable",
        label: "",
        hideLabel: true,
        hidden: filteredMergeTopics.length > 0,
        render: () => <NoDataAvailableDiv />,
      }]
    },
    ...filteredMergeTopics.map(mergeTopic => ({
      type: "collapsable-start-closed" as any,
      key: mergeTopic.label,
      title: mergeTopic.label,
      fields: getMergeFieldTopicFields(mergeTopic),
    }))]}
  />
}

const getMergeFieldTopicFields = (topic: server.dto.AvailableMergeFieldTopic): InPageEditableSectionField[] => {
  return topic.subTopics.filter(subTopic => subTopic.mergeFields.length > 0).flatMap(subTopic => getMergeFieldSubTopicFields(subTopic));
}

const getMergeFieldSubTopicFields = (subTopic: server.dto.AvailableMergeFieldSubTopic): InPageEditableSectionField[] => {
  return [{
    key: `${subTopic.label}-title`,
    label: subTopic.label,
    hideLabel: true,
    render: () => <h3>{subTopic.label}</h3>
  }, ...subTopic.mergeFields.map(mf => ({
    key: `${subTopic.label}-${mf.mergeField}`,
    label: mf.label,
    compact: true,
    render: () => <CopyToClipboard value={mf.mergeField} />
  }))]
}